import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import AddWorkOrderTestingContent from "./AddWorkOrderTestingContent";

export const AddWorkOrderTestingDialog = ({ workOrderId }) => {
  return (
    <HubDialogWrapper maxWidth="sm" name="add-work-order-test">
      <AddWorkOrderTestingContent workOrderId={workOrderId} />
    </HubDialogWrapper>
  );
};
